// @mui
import Grid from '@mui/material/Unstable_Grid2';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
// _mock
import {
    _analyticPosts,
    _appRelated
} from 'src/_mock';
// components
import { useSettingsContext } from 'src/components/settings';
import AnalyticsWebsiteVisits from 'src/sections/overview/analytics/analytics-website-visits';
import AnalyticsNews from 'src/sections/overview/analytics/analytics-news';
import AnalyticsTrafficBySite from 'src/sections/overview/analytics/analytics-traffic-by-site';
import Cards from './card';
import AppAreaInstalled from './area-installed';
import AppTopRelated from 'src/sections/overview/app/app-top-related';
import AnalyticsConversionRates from 'src/sections/overview/analytics/analytics-conversion-rates';
//


// ----------------------------------------------------------------------

export default function DashboardComponents() {
    const settings = useSettingsContext();
    const dashboardData = [
        {
            title: "Users",
            total: 4,
            color: "#e6999a",
            icon: "line-md:person-add-filled", // already valid
        },
        {
            title: "Connected",
            total: 1,
            color: "#f6c971",
            icon: "eva:link-2-fill", // replaced "network" with a connected-link icon
        },
        {
            title: "Meeting Schedule",
            total: 2,
            color: "#b7d7a8",
            icon: "eva:calendar-outline", // calendar icon
        },
        {
            title: "Meeting Done",
            total: 1,
            color: "#a3d2f2",
            icon: "eva:checkmark-circle-2-fill", // check icon
        },
        {
            title: "Lead Won",
            total: 1,
            color: "#aea8d3",
            icon: "eva:award-fill", // trophy/award icon
        },
        {
            title: "Assign to Sales Team 1",
            total: 2,
            color: "#f6c971",
            icon: "eva:people-outline", // team/people icon
        },
        {
            title: "Assign to Demo Team",
            total: 2,
            color: "#d6c2e9",
            icon: "eva:people-outline", // same team icon
        },
    ];
    const _analyticTraffic = [
        {
            label: 'Tiktok',
            icon: 'logos:tiktok-icon',
            value: 'tiktok',
            total: 420000,
            type: 'Followers',
            growth: 12,
        },
        {
            label: 'Instagram',
            icon: 'skill-icons:instagram',
            value: 'instagram',
            total: 980000,
            type: 'Followers',
            growth: 20,
        },
        {
            label: 'Youtube',
            icon: 'logos:youtube-icon',
            value: 'youtube',
            total: 230000,
            type: 'Subscribers',
            growth: 53,
        },
        {
            label: 'Facebook',
            icon: 'logos:facebook',
            value: 'facebook',
            total: 673000,
            type: 'Followers',
            growth: 23,
        },
    ];

    return (
        <Container maxWidth={ settings.themeStretch ? false : 'xl' }>
            <Typography
                variant="h4"
                sx={ {
                    mb: { xs: 3, md: 5 },
                } }
            >
                Marketing Dashboard
            </Typography>
            <Grid container spacing={ 2 }>
                <Grid container spacing={ 3 }>
                    { dashboardData?.map((item, index) => (
                        <Grid item xs={ 12 } md={ 3 } key={ index }>
                            <Cards
                                title={ item.title }
                                percent={ 3.6 } // You can customize this if needed
                                total={ item.total }
                                chart={ {
                                    series: [ 22, 8, 35, 50, 82, 84, 77, 12, 87, 43 ], // Optional, can be dynamic per card
                                } }
                                color={ item.color } // Optional, if your Cards component accepts color
                                icon={ item.icon }   // Optional, if Cards supports icons
                            />
                        </Grid>
                    )) }
                </Grid>
                <Grid xs={ 12 } md={ 6 } lg={ 12 }>
                    <AnalyticsTrafficBySite title="" list={ _analyticTraffic } />
                </Grid>
                <Grid xs={ 12 } md={ 6 } lg={ 12 }>
                    <AnalyticsWebsiteVisits
                        title="Followes"
                        subheader="Net Growth"
                        chart={ {
                            labels: [
                                '01/01/2003',
                                '02/01/2003',
                                '03/01/2003',
                                '04/01/2003',
                                '05/01/2003',
                                '06/01/2003',

                            ],
                            series: [
                                {
                                    name: 'Team A',
                                    type: 'column',
                                    fill: 'solid',
                                    data: [ 23, 11, 22, 27, 13, 22, 37, 21, 44, 22, 30 ],
                                },
                                // {
                                //     name: 'Team B',
                                //     type: 'area',
                                //     fill: 'gradient',
                                //     data: [ 44, 55, 41, 67, 22, 43, 21, 41, 56, 27, 43 ],
                                // },
                                // {
                                //     name: 'Team C',
                                //     type: 'line',
                                //     fill: 'solid',
                                //     data: [ 30, 25, 36, 30, 45, 35, 64, 52, 59, 36, 39 ],
                                // },
                            ],
                        } }
                    />
                </Grid>
                <Grid xs={ 12 } md={ 12 } lg={ 12 }>
                    <AppAreaInstalled
                        title={ ('Revenues') }
                        subheader={
                            <>
                                <Typography variant="h4" sx={ { m: 0, p: 0 } }>
                                    €11,223
                                </Typography>
                                {/* (+43%) than last year */ }
                            </>
                        }
                        chart={ {
                            categories: [ 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun' ],
                            series: [
                                {
                                    year: '2019',
                                    data: [
                                        {
                                            name: 'Revenue',
                                            data: [ 1000, 4983, 2003, 6001, 5221, 3241, 2322 ],
                                        },
                                        // {
                                        //   name: 'America',
                                        //   data: [10, 34, 13, 56, 77, 88, 99],
                                        // },
                                    ],
                                },
                                {
                                    year: '2020',
                                    data: [
                                        {
                                            name: 'Asia',
                                            data: [ 51, 35, 41, 10, 91, 69, 62 ],
                                        },
                                        // {
                                        //   name: 'America',
                                        //   data: [56, 13, 34, 10, 77, 99, 88],
                                        // },
                                    ],
                                },
                            ],
                        } }
                    />
                </Grid>
                <Grid xs={ 12 } md={ 6 } lg={ 12 }>
                    <AppTopRelated title="All Activities" list={ _appRelated } />
                </Grid>
                <Grid xs={ 12 } md={ 6 } lg={ 12 }>
                    <AnalyticsConversionRates
                        title="Top Countries"
                        // subheader="(+43%) than last year"
                        chart={ {
                            series: [
                                { label: 'Italy', value: 400 },
                                { label: 'Japan', value: 430 },
                                { label: 'China', value: 448 },
                                { label: 'Canada', value: 470 },
                                { label: 'France', value: 540 },

                            ],
                        } }
                    />
                </Grid>
                {/* <Grid xs={ 12 } md={ 6 } lg={ 8 }>
                    <AnalyticsNews title="News" list={ _analyticPosts } />
                </Grid> */}



            </Grid>
        </Container>
    );
}
